import { render, staticRenderFns } from "./ManyCategories.vue?vue&type=template&id=6d33c962&"
import script from "./ManyCategories.js?vue&type=script&lang=js&"
export * from "./ManyCategories.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./ManyCategories.txt?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fopt%2Fbuild%2Frepo%2Fsrc%2Fcomponents%2Fheader%2FCategoriesMenu%2FmanyCategories%2FManyCategories.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports